if (!customElements.get('localization-popup')) {
  var placeholderCountry = document.getElementById('CountryListInput').getAttribute('placeholder');
  var placeholderLanguage = document.getElementById('LanguageListInput').getAttribute('placeholder');
  class LocalizationPopup extends HTMLElement {
    
    constructor() {
      
      super();

      document.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.addEventListener('click', this.onContainerClick.bind(this));
      this.querySelectorAll('li').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      this.querySelector('button[type="submit"]').addEventListener('click', () => {
        zE("messenger:set", "cookies", false);
        localStorage.setItem('language_switched', 1);
      });
    }
    
    connectedCallback() {
      //this.show();
      document.addEventListener('show-localization-popup', (e) => {
        let group = e.detail.dataset.selector;
        console.log(group);
        if( document.querySelector('.localization-popup__group.active')) {
          document.querySelector('.localization-popup__group.active').classList.remove('active');
        }
        document.querySelector(`[data-tab="${group}"]`).classList.add('active');
        this.show();
      });
      // document.dispatchEvent(new CustomEvent('show-localization-popup'));
    }
    
    onContainerClick(event) {
      //console.log("click",event.target.dataset.target, event.target.getAttribute('data-action'))
      if (event.target.getAttribute('id') == 'shopify-section-localization-popup' || event.target.getAttribute('data-action') == 'close') {
        document.getElementById('CountryList').setAttribute("hidden", "");
        document.getElementById('LanguageList').setAttribute("hidden", "");
        this.hide();
      }
      if (event.target.dataset.target == undefined && event.target.getAttribute('id') == null) {
        document.getElementById('CountryList').setAttribute("hidden", "");
        document.getElementById('LanguageList').setAttribute("hidden", "");
      }
      if (event.target.dataset.target == 'CountryList' && event.target.getAttribute('id') !== 'CountryList'/* && document.getElementById('CountryList').hasAttribute('hidden')*/) {
        if(document.getElementById('CountryList').hasAttribute("hidden") != false){
          document.getElementById('CountryList').toggleAttribute("hidden")
        }
        document.getElementById('CountryListInput').classList.remove("init-hide");
        document.getElementById('LanguageList').setAttribute("hidden", "");
        document.querySelector('.localization-button[data-target="CountryList"]').placeholder = placeholderCountry;
        document.querySelector('.CountryListInput').hidden = true;
      }
      if (event.target.dataset.target == 'LanguageList' && event.target.getAttribute('id') !== 'LanguageList'/* && document.getElementById('LanguageList').hasAttribute('hidden')*/) {
        if(document.getElementById('LanguageList').hasAttribute("hidden") != false){
          document.getElementById('LanguageList').toggleAttribute("hidden");
        }
        document.getElementById('LanguageListInput').classList.remove("init-hide");
        document.getElementById('CountryList').setAttribute("hidden", "");
        document.querySelector('.localization-button[data-target="LanguageList"]').placeholder = placeholderLanguage;
        document.querySelector('.LanguageListInput').hidden = true;
      }
    }
    
    onContainerKeyUp(event) {
      if (!event || !event.code) return;
      if (event.code.toUpperCase() == 'ESCAPE') {
        this.hide();
        document.getElementById('CountryList').setAttribute("hidden", "");
        document.getElementById('LanguageList').setAttribute("hidden", "");
        return;
      }
    }
    
    onItemClick(e) {
      if (e.target.dataset.target == 'country_code') {
        document.getElementById('CountryList').toggleAttribute("hidden");
        // var svg = document.querySelector('.localization-button[data-target="CountryList"] svg').outerHTML;
        document.querySelector('.localization-button[data-target="CountryList"]').value = '';
        document.querySelector('.localization-button[data-target="CountryList"]').placeholder = '';
        document.querySelector('.CountryListInput').innerHTML = `${e.target.innerHTML}`;
        document.querySelector('.CountryListInput').hidden = false;
      }
      if (e.target.dataset.target == 'language_code') {
        document.getElementById('LanguageList').toggleAttribute("hidden");
        //var svg = document.querySelector('.localization-button[data-target="CountryList"] svg').outerHTML;
        //document.querySelector('.localization-button[data-target="LanguageList"]').innerHTML = `${e.target.innerHTML} ${svg}`;
        document.querySelector('.localization-button[data-target="LanguageList"]').value = '';
        document.querySelector('.localization-button[data-target="LanguageList"]').placeholder = '';
        document.querySelector('.LanguageListInput').innerHTML = `${e.target.innerHTML}`;
        document.querySelector('.LanguageListInput').hidden = false;
      }
      //console.log(this.querySelector(`input[name="${e.target.dataset.target}"]`))
      this.querySelector(`input[name="${e.target.dataset.target}"]`).value = e.target.dataset.value;
    }
    
    hide() {
      this.classList.remove('show');
    }
    
    show() {
      this.classList.add('show');
    }
  }
  
  customElements.define('localization-popup', LocalizationPopup);

  function filterList(listName) {
    // Declare variables
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById(listName+'ListInput');
    filter = input.value.toUpperCase();
    ul = document.getElementById(listName+"List");
    li = ul.getElementsByTagName('li');
    if (ul.getElementsByClassName('line-separator').length > 0) {
      ul.querySelector('.line-separator').style.display = "";      
    }
  
    // Loop through all list items, and hide those who don't match the search query
    for (i = 0; i < li.length; i++) {
      //a = li[i].getElementsByTagName("a")[0];
      txtValue = li[i].textContent || li[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        li[i].style.display = "";
      } else {
        if (ul.getElementsByClassName('line-separator').length > 0) {
          ul.querySelector('.line-separator').style.display = "none";
        }
        li[i].style.display = "none";
      }
    }
  }

}